/* eslint-disable react/prop-types */
import React, { memo, useCallback } from 'react';
import { ChatSmartTable } from '../../ChatSmartTable';
import type { ChatDSTemplateActionsListProps } from '../../ChatDSTemplate/type';

/** 从 ChatDSTemplateActionsListProps 中提取分享场景所需的类型 */
type IChatSmartTableShareProps = Pick<ChatDSTemplateActionsListProps, 'dsReport' | 'sessionId' | 'handleUpdateDsReport' | 'conversations'>;

/**
 * 分享场景下的智能表格只读包装组件
 * 职责：从分享场景的 props 中适配出 ChatSmartTable 所需的 props，固定传入 readonly={true}
 * 不复制任何渲染逻辑，仅做数据适配
 */
const ChatSmartTableShare: React.FC<IChatSmartTableShareProps> = memo(({
  dsReport,
  sessionId,
  handleUpdateDsReport,
  conversations = [],
}) => {
  // 分享场景下不需要发起新对话，提供空函数
  const noop = useCallback(() => {}, []);

  // 构造 ChatSmartTable 需要的 dsReport，确保 id 字段（即 file_id）存在
  const adaptedDsReport = {
    ...dsReport,
    // ChatSmartTable 内部使用 dsReport.id 作为 fileId 进行数据加载
    id: dsReport?.id,
    name: dsReport?.name || '',
  };
  return (
    <ChatSmartTable
      handleUpdateDsReport={handleUpdateDsReport}
      startNewConversation={noop}
      conversations={conversations}
      dsReport={adaptedDsReport}
      sessionId={sessionId}
      readonly={true}
    />
  );
});

ChatSmartTableShare.displayName = 'ChatSmartTableShare';

export default ChatSmartTableShare;
